module.exports = __webpack_public_path__ + "img/Leitender_Notarzt.573f733e.svg";